'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _applyConfigs = require('../utils/apply-configs');

var _applyConfigs2 = _interopRequireDefault(_applyConfigs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	type: 'SUB_MENU',
	name: 'Sub menu',
	allowedSections: ['footer', 'header', 'main'],
	disallowedChildren: [],
	category: 'Nav',
	requiredProps: [{
		name: 'categoryLinkId',
		inputType: 'link',
		label: 'Select page to drop in',
		default: '',
		requestKey: 'categoryId'
	}],
	props: [{
		name: 'url',
		inputType: 'link',
		label: 'Pick a parent category for your menu',
		default: '/',
		requestKey: 'linkFriendlyName'
	}, {
		name: 'iconClosed',
		inputType: 'icon',
		label: 'Choose icon to open menu',
		default: false
	}, {
		name: 'iconOpen',
		inputType: 'icon',
		label: 'Choose icon to close menu',
		default: false
	}, {
		name: 'iconSize',
		inputType: 'text',
		label: 'Size on icons',
		default: '1em'
	}, {
		name: 'displayIconBeforeTitle',
		inputType: 'checkbox',
		label: 'Display icon before title',
		default: false
	}, {
		name: 'showHiddenCategories',
		inputType: 'checkbox',
		label: 'Show hidden categories',
		default: false
	}, {
		name: 'includeParent',
		inputType: 'checkbox',
		label: 'Inlcude parent',
		default: false
	}, {
		name: 'closeOthers',
		inputType: 'checkbox',
		label: 'Keep maximum one path open at a time',
		default: false
	}, {
		name: 'linkTitle',
		inputType: 'checkbox',
		label: 'Remove link from title',
		default: false
	}, {
		name: 'renderParentLink',
		inputType: 'checkbox',
		label: 'Include parent link in sub-menu',
		default: false
	}, {
		name: 'parentLinkPrefix',
		inputType: 'text',
		label: 'Parent link prefix',
		default: 'All '
	}, {
		name: 'levels',
		inputType: 'number',
		label: 'Levels to include',
		default: 9
	}],
	hiddenProps: (0, _applyConfigs2.default)(['htmlclass'])
};